import React, { useRef, useEffect } from "react";
import { Bold, Italic, List, ListOrdered, Underline } from "lucide-react";

/** Lightweight contentEditable rich text editor. */
export default function RichEditor({ value, onChange, placeholder, testid }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line
  }, []);

  const exec = (cmd, arg = null) => {
    document.execCommand(cmd, false, arg);
    if (ref.current) onChange(ref.current.innerHTML);
  };

  return (
    <div>
      <div className="rte-toolbar">
        <button type="button" onClick={() => exec("bold")} data-testid={`${testid}-bold`}><Bold size={13} /></button>
        <button type="button" onClick={() => exec("italic")} data-testid={`${testid}-italic`}><Italic size={13} /></button>
        <button type="button" onClick={() => exec("underline")} data-testid={`${testid}-underline`}><Underline size={13} /></button>
        <button type="button" onClick={() => exec("insertUnorderedList")} data-testid={`${testid}-ul`}><List size={13} /></button>
        <button type="button" onClick={() => exec("insertOrderedList")} data-testid={`${testid}-ol`}><ListOrdered size={13} /></button>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        data-testid={testid}
        data-placeholder={placeholder}
        className="rte-editable text-sm text-slate-800"
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
      />
    </div>
  );
}
